/** 툴바 비활성 호버 미니모달 */
export const PROGRAM_IMPORT_LEARNING_CONTENT_BLOCKED_HINT =
  '프로그램 내용이 없어야 가져올 수 있습니다.';

export const PROGRAM_IMPORT_LEARNING_SYNC_MIRROR_HINT =
  '동기화 화면에서는 가져올 수 없습니다.';

export function resolveProgramImportLearningDisabledHint(opts: {
  contentBlocked: boolean;
  syncMirror?: boolean;
}): string | null {
  if (opts.syncMirror) return PROGRAM_IMPORT_LEARNING_SYNC_MIRROR_HINT;
  if (opts.contentBlocked) return PROGRAM_IMPORT_LEARNING_CONTENT_BLOCKED_HINT;
  return null;
}
